import { render } from "./PurchaseReturnList.vue?vue&type=template&id=b4a0f5f4"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__